import {Button, ButtonProps, Card, CardActions, CardContent, Typography} from '@material-ui/core';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import React from 'react';
import {useCardActionStyles, useCustomCardHeaderStyles, useQuotingCardStyles} from './styles';

export type CardAction = {
  label: string;
  handlerFn: (...args: any[]) => void;
  props?: ButtonProps;
};

type CustomCardHeaderProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  actions?: CardAction[];
  titleAsHeader?: boolean;
};

type QuotingCardProps = Partial<{
  children: React.ReactNode;
  title: React.ReactNode;
  headerActions: CardAction[];
  subtitle: React.ReactNode;
  footerActions: CardAction[];
  titleAsHeader: boolean;
  ariaLandmarkName: string;
}>;

const CardAction = ({actions}: {actions: CardAction[]}) => {
  const classes = useCardActionStyles();
  return (
    <CardActions className={classes.cardActions}>
      {actions?.map(({label, handlerFn, props}) => (
        <Button onClick={handlerFn} className={'classes.actionBtn'} key={toKebabCase(label)} {...props}>
          {label}
        </Button>
      ))}
    </CardActions>
  );
};

const CustomCardHeader = (props: CustomCardHeaderProps) => {
  const {title, subtitle, actions, titleAsHeader} = props;
  const classes = useCustomCardHeaderStyles();

  return titleAsHeader ? (
    <div className={classes.header}>{title}</div>
  ) : (
    <div className={classes.header}>
      <div>
        <Typography className={classes.title}>{title}</Typography>
        {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
      </div>
      {actions && <CardAction actions={actions} />}
    </div>
  );
};

export const QuotingCard = (props: QuotingCardProps) => {
  const {children, title, headerActions, subtitle, footerActions, titleAsHeader, ariaLandmarkName} = props;
  const classes = useQuotingCardStyles();

  return (
    <section className={classes.cardWrapper} aria-label={ariaLandmarkName}>
      <Card className={classes.card}>
        <CustomCardHeader title={title} subtitle={subtitle} actions={headerActions} titleAsHeader={titleAsHeader} />
        {children && <CardContent>{children}</CardContent>}
        {footerActions && <CardAction actions={footerActions} />}
      </Card>
    </section>
  );
};
